<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{voucher.name}}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        {{'Included services'|translate}}:<br/>
        <ul>
            <li *ngFor="let item of voucher.services">{{item.quantity}} x {{item.service.name}}</li>
        </ul>
        <p>
            {{'Price gross'|translate}}: {{voucher.salePrice}}<br/>
            {{'VAT rate'|translate}}: {{voucher.vatRate.vatName}}
        </p>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="OK">
            {{'OK'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close('add-to-bill')"
                aria-label="Add to bill"
        >
            {{'Add to bill'|translate}}
        </button>

    </div>
</div>
